<router-outlet></router-outlet>
<xyz-shared-icons></xyz-shared-icons>
  